import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, MapPin } from "lucide-react"; // Added MapPin
import { PopupModal } from "react-calendly";

// Reworked Hero Component
function Hero() {
	const [openBooking, setOpenBooking] = useState(false);

	return (
		<section className="relative bg-gradient-to-b from-gray-50 to-white pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden">
			{/* Enhanced Background Image - More visible and aspirational */}
			<div
				className="absolute inset-0 bg-cover bg-center opacity-50" // Slightly increased opacity
				style={{
					backgroundImage: "url('/images/hero_room.jpg')", // Suggest using a brighter/clearer hero image
					// Apply a subtle blur or gradient overlay if needed to ensure text readability
					// maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 80%, rgba(0,0,0,0))', // Optional fade at bottom
				}}
			/>
			{/* Overlay for text readability */}
			<div className="absolute inset-0 bg-white/30 sm:bg-white/10 md:bg-transparent bg-gradient-to-r from-white/70 via-white/20 to-transparent"></div>

			<div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
				<div className="max-w-2xl text-center sm:text-left">
					{/* Headline - Clearer Benefit & Scope */}
					<motion.h1
						initial={{ opacity: 0, x: -30 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.5, ease: "easeOut" }}
						className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 tracking-tight"
					>
						Custom Window Shades,{" "}
						<span className="text-primary">Made Simple.</span>
						<br /> {/* Force line break for clarity */}
						<span className="text-secondary">Save Up To 50%.</span>{" "}
						{/* Prominent Savings */}
					</motion.h1>

					{/* Subheadline - Reinforce Key Selling Points (Customer Obsession: Address quality, origin, ease) */}
					<motion.p
						initial={{ opacity: 0, x: -30 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
						className="mt-4 text-lg md:text-xl text-gray-700"
					>
						Transform your space with premium, handcrafted shades made right
						here in Toronto. Get the perfect fit, style, and price, delivered
						fast.
					</motion.p>

					{/* CTAs - Clear Primary and Secondary Actions */}
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
						className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4"
					>
						<Link
							to="/shop" // Direct link to product browsing/customization
							className="border-2 border-primary inline-block w-full sm:w-auto bg-primary text-white px-8 py-3 rounded-lg font-semibold text-lg text-center shadow-md hover:bg-primary/90 transition-all duration-300"
						>
							Shop All Shades
						</Link>
						<Link
							to="/swatches" // Promote free samples early (Reduces customer risk)
							className="inline-block w-full sm:w-auto border-2 border-secondary text-secondary px-8 py-3 rounded-lg font-semibold text-lg text-center hover:bg-secondary/10 transition-all duration-300"
						>
							Get Free Samples
						</Link>
						{/* Optional: Consultation Button - Kept less prominent than Shop/Samples initially */}
						{/* <button
                            onClick={() => setOpenBooking(true)}
                            className="inline-block w-full sm:w-auto text-gray-600 hover:text-primary font-medium text-center transition-all duration-300"
                        >
                            Book Free Consultation
                        </button> */}
					</motion.div>

					{/* Trust Badges - More Specific and Trust-Building */}
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.6, ease: "easeOut" }}
						className="mt-8 flex flex-col sm:flex-row gap-4 sm:gap-6 text-sm text-gray-600"
					>
						<div className="flex items-center gap-1.5">
							<CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
							<span>Free Shipping Canada-Wide</span>
						</div>
						<div className="flex items-center gap-1.5">
							<MapPin className="w-5 h-5 text-primary flex-shrink-0" />
							<span>Handcrafted in Toronto</span>
						</div>
						{/* Consider adding a star rating if you have good aggregated reviews */}
						{/* <div className="flex items-center gap-1.5">
                            <Star className="w-5 h-5 text-yellow-500 flex-shrink-0" />
                            <span>4.9/5 Customer Rating</span>
                        </div> */}
					</motion.div>
				</div>
			</div>

			{/* Calendly Popup Modal */}
			<PopupModal
				url="https://calendly.com/offcutshades"
				rootElement={document.getElementById("root")}
				open={openBooking}
				onModalClose={() => setOpenBooking(false)}
				// Use default Calendly styling or pass specific props if needed
			/>
		</section>
	);
}

export default Hero;
